module.exports = __webpack_public_path__ + "static/img/zhifubao.f4f0983.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhifubao.png
// module id = A/aW
// module chunks = 1